<template>
<div>
    <Breadcrumbs main="Inventory" title="Product Information" />
    <div style="padding: 0px 12px; margin-bottom: 16px; display: flex; justify-content: end;">
            <b-button variant="primary" @click="goBack">
                <div style="display: flex; align-items: center; gap: 8px;">
                    <feather type="arrow-left" size="18px"></feather>
                    <h7>Back</h7>
                </div>
            </b-button>
        </div>
    <div class="row">
        <!-- Left Column (Other Info) -->
        <div class="col-xl-7">
            <div class="card">
                <div class="card-body">

                    <div>
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="mb-0">Stock Details</h6>
                            <feather type="plus-square" size="20px" style="color:#568ae3; cursor:pointer" v-b-tooltip.hover title="Add Lot" v-b-modal.lot-item-modal />

                        </div>

                        <b-table show-empty sticky-header :items="details.stock_lots" :fields="stock_information" head-variant="light">
                            <template #cell(index)="data">
                                # {{ data.index + 1 }}
                                
                            </template>

                             <template #cell(lot_number)="data">
                                    <div class="d-flex flex-column">
                                        <h7 v-if="data.item.lot_number"><strong class="mr-1">{{ data.item.lot_number }}</strong></h7>
                                         <h7 v-if="data.item.received_on" style="font-size: 12px;"><strong class="mr-1">Received On: </strong>{{ data.item.received_on }}</h7>
                                         <h7 v-if="data.item.expiry_date" style="font-size: 12px;"><strong class="mr-1">Expiry Date: </strong>{{ data.item.expiry_date }}</h7>
                                    </div>
                                
                            </template>

                              
                            <template #cell(stock)="data">
                                <div class="d-flex flex-column">
                                    <h7 v-if="data.item.stock_quantity"><strong class="mr-1">Total: </strong>{{ data.item.stock_quantity }}</h7>
                                    <h7 v-if="data.item.remaining_stock"><strong class="mr-1">Remaining: </strong>{{ data.item.remaining_stock }}</h7>
                                    <h7 v-if="data.item.committed_stock > 0"><strong class="mr-1">Committed: </strong>{{ data.item.committed_stock }}</h7>
                                </div>
                            </template>
                            <template #cell(cost)="data">
                                <div class="d-flex flex-column">
                                    <h7 v-if="data.item.lot_unit_cost"><strong class="mr-1">Unit Cost: </strong>{{ data.item.lot_unit_cost }}</h7>
                                    <h7 v-if="data.item.lot_total_cost"><strong class="mr-1">Total Cost: </strong>{{ data.item.lot_total_cost }}</h7>

                                </div>
                            </template>
                            <template #cell(option)="data">
                                <div class="d-flex flex-column">
                                    <feather type="edit" size="20px" style="color:#568ae3; cursor:pointer" v-b-tooltip.hover title="Edit" @click="editLot(data.item)" v-b-modal.lot-edit-modal/>
                                </div>
                            </template>

                        </b-table>
                    </div>

                </div>
            </div>
        </div>

        <!-- Right Column (Full Details) -->
        <div class="col-xl-5">
            <div class="card">
                <div class="card-body">

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h5 class="mb-0">Product Details</h5>
                        <feather type="edit" size="20px" style="color:#568ae3; cursor:pointer" v-b-tooltip.hover title="Edit" @click="editProduct($route.params.id)" />

                    </div>

                    <!-- Top section: Details + Image -->
                    <div class="row mb-3">

                        <!-- Left details -->
                        <div class="col-8">

                            <div class="row mb-2">
                                <div class="col-5 fw-bold">Name</div>
                                <div class="col-7">{{ product.name }}</div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-5 fw-bold">SKU</div>
                                <div class="col-7">{{ product.sku }}</div>
                            </div>

                            <div class="row mb-2" v-if="product.category">
                                <div class="col-5 fw-bold">Category</div>
                                <div class="col-7">{{ product.category?.name }}</div>
                            </div>

                            <div class="row mb-2" v-if="product.subcategory">
                                <div class="col-5 fw-bold">Subcategory</div>
                                <div class="col-7">{{ product.subcategory?.name }}</div>
                            </div>

                        </div>

                        <!-- Right image -->
                        <div class="col-4 text-end">
                            <img v-if="product.image" :src="host + product.image" class="img-fluid rounded border" style="max-height:140px; object-fit:cover;">
                        </div>

                    </div>

                    <!-- Remaining details -->
                    <div class="row mb-2">
                        <div class="col-5 fw-bold">Brand</div>
                        <div class="col-7">{{ product.brand }}</div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-5 fw-bold">Sell Price</div>
                        <div class="col-7">{{ product.sell_price }}</div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-5 fw-bold">Stock</div>
                        <div class="col-7">{{ product.stock_quantity }}</div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-12">
                            <strong>Description</strong>
                            <div v-html="product.description"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <b-modal id="lot-item-modal" ref="modal" title="Add Lot Item" @show="resetModal" @hidden="resetModal" @ok="handleOk">

        <form ref="form" @submit.stop.prevent="handleSubmit">

            <div class="row">

                <!-- Product -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Product</label>
                        <input type="text" class="form-control" step="1" min="0" v-model="details.name" disabled placeholder="Enter quantity" />
                    </div>
                </div>

                <!-- Received On -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Product Received On</label>
                        <datepicker placeholder="Select date" input-class="form-control" v-model="lot_item.received_on" />
                    </div>
                </div>

                <!-- Stock Quantity -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Stock Quantity</label>
                        <input type="number" class="form-control" step="1" min="0" v-model="lot_item.stock_quantity" placeholder="Enter quantity" />
                    </div>
                </div>

                <!-- Lot Unit Cost -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Lot Unit Cost</label>
                        <input type="number" step="50" class="form-control" v-model="lot_item.lot_unit_cost" placeholder="Enter cost" />
                    </div>
                </div>

                <!-- Expiry Date -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Expiry Date</label>
                        <datepicker placeholder="Select expiry date" input-class="form-control" v-model="lot_item.expiry_date" />
                    </div>
                </div>

            </div>

        </form>
    </b-modal>
    
    <b-modal id="lot-edit-modal" ref="modal-edit" title="Edit Lot Item"  @ok="handleLotOk">

        <form ref="form" @submit.stop.prevent="handleLotEditSubmit">

            <div class="row">

                <!-- Product -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Product</label>
                        <input type="text" class="form-control" step="1" min="0" v-model="details.name" disabled placeholder="Enter quantity" />
                    </div>
                </div>

                <!-- Received On -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Product Received On</label>
                        <datepicker placeholder="Select date" input-class="form-control" v-model="edit_lot.received_on" />
                    </div>
                </div>

                <!-- Stock Quantity -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Stock Quantity</label>
                        <input type="number" class="form-control" step="1" min="0" v-model="edit_lot.stock_quantity" placeholder="Enter quantity" />
                    </div>
                </div>

                <!-- Lot Unit Cost -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Lot Unit Cost</label>
                        <input type="number" step="50" class="form-control" v-model="edit_lot.lot_unit_cost" placeholder="Enter cost" />
                    </div>
                </div>

                <!-- Expiry Date -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Expiry Date</label>
                        <datepicker placeholder="Select expiry date" input-class="form-control" v-model="edit_lot.expiry_date" />
                    </div>
                </div>

            </div>

        </form>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    computed
} from "vue";
import moment from "moment";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    myHost
} from '../../../../_helpers/host'

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        'v-select': vSelect

    },

    data() {
        return {
            host: myHost.host,
            product: {
                name: '',
                sku: '',
                // received_on:null,
                category: null,
                subcategory: null,

                description: '',

                brand: '',
                unit: '',
                origin: '',
                distributor: '',

                sell_description: '',
                purchase_description: '',

                sell_price: null,
                cost_price: null,
                offer_price: null,

                stock_quantity: 0,

                tags: [],
                tagInput: '',
                image: null
            },
            lot_item: {
                product: null,
                received_on: null,
                stock_quantity: null,
                lot_unit_cost: null,
                expiry_date: null
            },

            edit_lot:{
                product: null,
                received_on: null,
                stock_quantity: null,
                lot_unit_cost: null,
                expiry_date: null
            },
            units: [
                'pcs',
  'kg',
  'litre',
  'box',
  'set',
  'metre',
  'pack',
  'other'
            ],
            selectedFileName: '',
            currentImage: null,
            stock_information: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'lot_number',
                    label: 'Lot Number',
                    sortable: true
                },
                {
                    key: 'stock',
                    label: 'Stock Details',
                    sortable: true
                },
                {
                    key: 'cost',
                    label: 'Cost',
                    sortable: true
                },
                {
                    key: 'option',
                    label: 'Option',
                    sortable: true
                }
            ],
            editID: null

        };
    },

    computed: {
        ...mapState({
            // category_list: state => state.inventory.categories,
            // subcategory_list: state => state.inventory.sub_categories,
            details: state => state.inventory.product_details,

        })
    },

    mounted() {
        // this.$store.dispatch("inventory/fetchCategories")
        this.$store.dispatch("inventory/fetchProductDetails", this.$route.params.id)
    },

    watch: {
        details(newVal, oldVal) {
            if (!newVal) return
            this.currentImage = this.host + newVal.image,
                this.product = {
                    name: newVal.name || '',
                    sku: newVal.sku || '',
                    category: newVal.category || null,
                    subcategory: newVal.subcategory || null,

                    description: newVal.description || '',
                    // received_on : newVal.received_on || null,

                    brand: newVal.brand || '',
                    unit: newVal.unit || '',
                    origin: newVal.origin || '',
                    distributor: newVal.distributor || '',

                    sell_description: newVal.sell_description || '',
                    purchase_description: newVal.purchase_description || '',

                    sell_price: newVal.sell_price || null,
                    cost_price: newVal.cost_price || null,
                    offer_price: newVal.offer_price || null,
                    image: newVal.image || null,

                    stock_quantity: newVal.stock_quantity || 0,

                    tags: newVal.tags || []
                }
        },
        // 'product.category'(newVal) {

        //     if (newVal) {
        //         this.fetchSubCategory(newVal)
        //     }
        // }
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },

        editProduct(id) {
            this.$router.push(`/inventory/product/edit/${id}`)
        },

        resetModal() {
            this.lot_item = {
                product: null,
                received_on: null,
                stock_quantity: null,
                lot_unit_cost: null,
                expiry_date: null
            }
        },

        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {

             
            let lot_item = {
                product: this.$route.params.id,
                received_on: this.formatDate(this.lot_item.received_on),
                stock_quantity: this.lot_item.stock_quantity,
                lot_unit_cost: this.lot_item.lot_unit_cost,
                expiry_date: this.formatDate(this.lot_item.expiry_date)
            }

            this.$store.dispatch("inventory/addProductLot", {
                product_info: lot_item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                  

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            
             this.$nextTick(() => {
                this.$bvModal.hide("lot-item-modal")
            })
         


        },
        formatDate(date) {
             return date ? moment(String(date)).format("YYYY-MM-DD") : null
        },
        editLot(data){
            this.editID = data.id
            this.edit_lot = {
                product: this.$route.params.id,
                received_on: data.received_on,
                stock_quantity:data.stock_quantity,
                lot_unit_cost:data.lot_unit_cost,
                expiry_date: data.expiry_date
            }
        },
        // resetLotModal() {
        //     this.editID = null
        //     this.edit_lot = {
        //         product: null,
        //         received_on: null,
        //         stock_quantity: null,
        //         lot_unit_cost: null,
        //         expiry_date: null
        //     }
        // },

        handleLotOk(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.handleLotEditSubmit()
        },

        handleLotEditSubmit() {

             
            let lot_item = {
                product: this.$route.params.id,
                received_on: this.formatDate(this.edit_lot.received_on),
                stock_quantity: this.edit_lot.stock_quantity,
                lot_unit_cost: this.edit_lot.lot_unit_cost,
                expiry_date: this.formatDate(this.edit_lot.expiry_date)
            }

            this.$store.dispatch("inventory/updateProductLot", {
                product_info: lot_item,
                id: this.editID
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                 

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
             this.$nextTick(() => {
               this.$bvModal.hide("lot-edit-modal")
            })

            

        
        },


    }
};
</script>

<style scoped>

</style>
